import { render, staticRenderFns } from "./AthleteSchoolSearch.vue?vue&type=template&id=079dd718&scoped=true&"
import script from "./AthleteSchoolSearch.vue?vue&type=script&lang=ts&"
export * from "./AthleteSchoolSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSchoolSearch.vue?vue&type=style&index=0&id=079dd718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079dd718",
  null
  
)

export default component.exports